import { Banner } from '../banner/Banner';

const bannerContent = {
    header: 'Det er 27°C på Tenerife i vinter',
    text: 'Få litt varme i kroppen på Kanariøyene, da vel!',
    callToAction: 'Se våre reisetips',
    link: 'https://www.finn.no/reise/artikler/solreiser/reisetips-til-tenerife-pa-kanarioyene',
    img: {
        src: 'https://finn-content-hub.imgix.net/bilder/GettyImages-1264675861.jpg?auto=format,compress&fit=crop&crop=focalpoint&fp-x=0.5319&fp-y=0.5714&fp-z=1.1&w=470&h=300',
        width: 470,
        height: 300,
        alt: '',
    },
};

export const FrontpageBanner = () => {
    const { header, text, callToAction, link, img } = bannerContent;

    return <Banner header={header} text={text} callToAction={callToAction} link={link} imgType="img" img={img} />;
};
